export const UserRole = {
  Tester: 2,
}

export const ProjectType = {
  Fix: 1,
  Ransom: 2,
  TM: 3,
  BatchSupport: 4,
}
